import { Dialog } from '@cimplico/components';
import { toastNotification } from '../../components/toast/Toast';
import { useDeleteClientQueryReply } from '../../queries/use-delete-client-query-reply';

type ClientQueryReplyDeleteConfirmProps = {
    workpaperId: string;
    clientQueryId: string;
    replyId: string;
    onClose: () => void;
    onDelete: () => void;
};

function ClientQueryReplyDeleteConfirm({
    clientQueryId,
    workpaperId,
    replyId,
    onClose,
    onDelete,
}: ClientQueryReplyDeleteConfirmProps): JSX.Element {
    const deleteClientQueryReplyQuery = useDeleteClientQueryReply(workpaperId, clientQueryId);

    function deleteClientQueryReply(): void {
        deleteClientQueryReplyQuery.mutate(
            { id: replyId },
            {
                onSuccess: () => {
                    onDelete();
                    toastNotification('success', 'Client query reply deleted!');
                },
            }
        );
    }

    return (
        <Dialog
            title="Delete Reply"
            description="Do you want to delete this client query reply?"
            isOpen
            primaryAction="Delete"
            secondaryAction="Cancel"
            type="error"
            onClose={onClose}
            onPrimaryActionClick={deleteClientQueryReply}
            onSecondaryActionClick={onClose}
            isLoading={deleteClientQueryReplyQuery.isLoading}
        />
    );
}
export default ClientQueryReplyDeleteConfirm;
